import { logger } from "@/lib/default-logger";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function ReturnPolicy() {
  const { settings } = useSelector((state: any) => state.settings);
  const [returnPolicy, setReturnPolicy] = useState<any>(null);
  useEffect(() => {
    const about = settings.find(
      (setting: any) => setting.key === "returnPolicy"
    );
    if (settings) {
      logger.log(about?.value);
      setReturnPolicy(about?.value);
    }
  }, [settings]);
  return (
    <div className="container mx-auto">
      <section className="py-8 relative bg-[#a8def5] px-8 rounded shadow md:max-w-5xl lg:w-3/4 ">
        <div className="flex items-center max-w-6xl mx-auto ">
          <div className="w-full py-4 px-12 order-1 justify-items-center">
            <div className="text text-justify">
              <h1 className="text-2xl tracking-tight font-extrabold text-gray-900 sm:text-3xl md:text-4xl mb-2 hidden ">
                {returnPolicy?.title}
              </h1>

              <div
                className=""
                dangerouslySetInnerHTML={{ __html: returnPolicy?.content }}
              ></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
